import { Toaster as SonnerToaster, toast as sonnerToast } from 'sonner';
import { getTheme } from '@/lib/theme.js';

// Sonner-based toast layer. Mount once at the AppShell root; call
// `toast(message)` / `toast.success()` / `toast.error()` from anywhere.
//
// Styling: matches the locked tokens (surface, border, accent for
// destructive, success/warning/info for semantic toasts).

export function Toaster() {
  return (
    <SonnerToaster
      position="top-center"
      theme={getTheme()}
      richColors={false}
      closeButton
      toastOptions={{
        unstyled: false,
        classNames: {
          toast:
            'group toast rounded-card border border-border bg-surface text-text shadow-2xl',
          title: 'text-sm font-medium text-text',
          description: 'text-sm text-text-muted',
          actionButton: 'bg-accent text-white',
          cancelButton: 'bg-border/60 text-text',
          error: 'border-accent/40 bg-accent-soft text-accent',
          success: 'border-success/40 bg-success-soft text-success',
          warning: 'border-warning/40 bg-warning-soft text-warning',
          info: 'border-info/40 bg-info-soft text-info',
        },
      }}
    />
  );
}

export const toast = sonnerToast;
